<template>
  <div class="create-team-container">
    <div class="create-team-box">
      <el-form
        ref="teamForm"
        v-loading="saveLoading"
        :model="teamForm"
        :rules="teamRules"
        class="create-team-form"
        label-width="120px"
        @submit.prevent="createTeam"
      >
        <el-form-item
          :label="$t('views.user_center.team_name')"
          prop="name"
        >
          <el-input
            v-model="teamForm.name"
            :placeholder="$t('views.user_center.enter_team_name')"
          />
        </el-form-item>
<!--        <el-form-item
          :label="$t('views.user_center.industry')"
          prop="industry_id"
        >
          <el-cascader
            v-model="teamForm.industry_id"
            style="width: 100%"
            :options="industryOption"
            :props="industryOptionProps"

            @change="industryChange"
          />
        </el-form-item>
        <el-form-item
          :label="$t('views.user_center.company_size')"
          prop="scale"
        >
          <el-select
            v-model="teamForm.scale"
            class="team-scale"
            :placeholder="$t('views.user_center.select_company_size')"
          >
            <el-option
              v-for="item in scaleOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>-->
      </el-form>
    </div>

  </div>
</template>

<script>
import { getTreeIndustry } from '@/api/dict'
import { createTeam } from '@/api/team'

export default {
  name: 'CreateTeam',
  components: {},
  props: {
    isDialog: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      teamForm: {
        name: '',
        industry_id: '',
        scale: ''
      },
      teamRules: {
        name: [
          { required: true, message: this.$t('views.user_center.enter_team_name'), trigger: 'blur' },
          { min: 3, max: 100, message: this.$t('views.user_center.team_name_length'), trigger: 'blur' }
        ],
/*        industry_id: [
          { required: true, message: this.$t('views.user_center.industry_required'), trigger: 'blur' }
        ],
        scale: [
          { required: true, message: this.$t('views.user_center.size_required'), trigger: 'blur' }
        ]*/
      },
      scaleOption: [
        { label: this.$t('views.user_center.size_1_10'), value: '1~10人' },
        { label: this.$t('views.user_center.size_11_50'), value: '11~50人' },
        { label: this.$t('views.user_center.size_51_100'), value: '51~100人' },
        { label: this.$t('views.user_center.size_101_300'), value: '101~300人' },
        { label: this.$t('views.user_center.size_301_1000'), value: '301~1000人' },
        { label: this.$t('views.user_center.size_1001_plus'), value: '1001人及以上' }
      ],
      industryOption: [],
      industryOptionProps: {
        expandTrigger: 'hover',
        label: 'name',
        value: 'id'
      },
      saveLoading: false
    }
  },
  mounted() {
    this.getIndustry()
  },
  methods: {
    industryChange() {

    },
    createTeam() {
      this.$refs['teamForm'].validate((valid) => {
        if (valid) {
          const params = {}
          params.name = this.teamForm.name
          params.industry_id = this.teamForm.industry_id[this.teamForm.industry_id.length - 1]
          params.scale = 0
          if (this.saveLoading) {
            return false
          }
          this.saveLoading = true
          createTeam(params).then(response => {
            this.saveLoading = false
            if (response && response.code === 0) {
              if (this.isDialog) {
                this.$message.success(this.$t('views.user_center.team_created'))
                this.$emit('update-team', response.data)
              }
            }
          }).catch(() => {
            this.saveLoading = false
          })
        } else {
          return false
        }
      })
    },
    initCreateTeam() {
      this.teamForm.name = ''
      this.teamForm.industry_id = ''
      this.teamForm.scale = ''
    },
    getIndustry() {
      getTreeIndustry({}).then(response => {
        if (response && response.code === 0) {
          this.industryOption = response.data
        }
      }).catch(() => {

      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/views/user_center/components/create_team";
</style>
